import { RootStore } from "./RootStore";
import {
  getUsers,
  createUser,
  deleteUser,
  getUser,
  updateUser,
  updateProfile,
} from "../vendor";
import { Status } from "../vendor/types";

export class UserStore {
  protected rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  public getUsers = async (limit: number, offset: number, all: boolean) => {
    try {
      return await getUsers(limit, offset, all);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter a lista de usuários.",
        "error"
      );
      return null;
    }
  };

  public getUser = async (username: string) => {
    try {
      return await getUser(username);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter o usuário.",
        "error"
      );
      return null;
    }
  };

  public create = async (data: {
    email: string;
    username: string;
    password: string;
    fullName: string;
    groupPermission: string;
    status: Status;
    allowPartners: number[];
    allowAllPartners: boolean;
  }) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      const user = await createUser(data);

      this.rootStore.generalStore.setShowLoading(false);

      return user;
    } catch (err) {
      this.rootStore.generalStore.setShowLoading(false);

      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível criar esse usuário.",
        "error"
      );
    }
  };

  public updateUser = async (
    data: {
      email?: string;
      username?: string;
      password?: string;
      fullName?: string;
      groupPermission?: string;
      status?: Status;
      allowPartners?: number[];
      allowAllPartners?: boolean;
    },
    id: number
  ) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      await updateUser(data, id);

      this.rootStore.routerStore.push("/dashboard/users");
      this.rootStore.generalStore.showSnackbar(
        "Usuário editado com sucesso!",
        "success"
      );
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível editar esse usuário.",
        "error"
      );
    } finally {
      this.rootStore.generalStore.setShowLoading(false);
    }
  };

  public updateProfile = async (data: {
    email?: string;
    username?: string;
    password?: string;
    fullName?: string;
  }) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      await updateProfile(data);

      this.rootStore.routerStore.push("/dashboard");
      this.rootStore.generalStore.showSnackbar(
        "Usuário editado com sucesso!",
        "success"
      );
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível editar esse usuário.",
        "error"
      );
    } finally {
      this.rootStore.generalStore.setShowLoading(false);
    }
  };

  public deleteUser = async (id: number) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      await deleteUser(id);
      this.rootStore.generalStore.showSnackbar(
        "Usuário deletado com sucesso!",
        "success"
      );

      this.rootStore.generalStore.setShowLoading(false);

      return true;
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível deletar esse usuário.",
        "error"
      );

      this.rootStore.generalStore.setShowLoading(false);

      return false;
    }
  };
}
